module["exports"] = [
  "A#? #?#",
  "B#? #?#",
  "C#? #?#",
  "E#? #?#",
  "G#? #?#",
  "H#? #?#",
  "J#? #?#",
  "K#? #?#",
  "L#? #?#",
  "M#? #?#",
  "N#? #?#",
  "P#? #?#",
  "R#? #?#",
  "S#? #?#",
  "T#? #?#",
  "V#? #?#",
  "X#? #?#",
  "Y#? #?#",
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fr_CA/address/postcode.js
// module id = 2990
// module chunks = 1610